var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "v-card", class: { "v-card--is-ghostly": _vm.isGhostly } },
    [
      _c("div", {
        staticClass: "v-card__vertical-position",
        attrs: { id: _vm.sectionId }
      }),
      _vm._v(" "),
      _vm.$slots.header
        ? _c(
            "div",
            {
              staticClass: "v-card__header",
              class: {
                "v-card__header--is-toggler": _vm.toggle,
                "v-card__header--is-toggler--is-open": _vm.isOpenControl
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  _vm.toggle ? (_vm.isOpenControl = !_vm.isOpenControl) : false
                }
              }
            },
            [_vm._t("header")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isOpenControl,
                expression: "isOpenControl"
              }
            ],
            staticClass: "v-card__body",
            class: {
              "v-card__body--has-no-padding": !_vm.padding,
              "v-card__body--scrollable": _vm.scrollable
            }
          },
          [_vm._t("default")],
          2
        )
      ]),
      _vm._v(" "),
      _vm.$slots.footer
        ? _c("div", { staticClass: "v-card__footer" }, [_vm._t("footer")], 2)
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1dc67c8b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dc67c8b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin/components/VCard.vue
// module id = 263
// module chunks = 1 2